import { render, staticRenderFns } from "./CierreResurrecion.vue?vue&type=template&id=37e4b1ac&"
import script from "./CierreResurrecion.vue?vue&type=script&lang=js&"
export * from "./CierreResurrecion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports